import { Card } from '@/types/credit';
import { Cardvariant } from '@/types/financialInstitution';
import { Loan } from '@/types/loan';
import { formatCurrency } from '@/utils';

const BASE_IMG_URL = process.env.NEXT_PUBLIC_IMAGE_DOMAIN_BASE_URL;

type variant = 'primary' | 'secondary';

export function mapCardsData(cards: Card[], variant?: variant) {
  const mappedCards = cards.map((card) => {
    let minimumIncomeValue: string;
    if (!+card.minIncome) {
      minimumIncomeValue = 'cards.noInfo';
    } else {
      minimumIncomeValue = card.minIncome
        ? formatCurrency(card.minIncome, card.currencySymbol).toString()
        : 'cards.noInfo';
    }

    let annualFeeValue: string;
    const cleanedAnnualFee = card.annualFee.replace(',', '');
    const annualFeeNumericValue = +cleanedAnnualFee.replace(/[^\d.-]/g, '');

    if (!annualFeeNumericValue) {
      annualFeeValue = 'cards.noAnnualFee';
    } else if (
      isNaN(annualFeeNumericValue) ||
      cleanedAnnualFee !== annualFeeNumericValue.toString()
    ) {
      // Se não for um número ou se a conversão para número não corresponde ao valor original, mantém o texto original
      annualFeeValue = card.annualFee || 'cards.noInfo';
    } else {
      // Caso contrário, formata como moeda
      annualFeeValue =
        formatCurrency(annualFeeNumericValue, card.currencySymbol) ||
        'cards.noInfo';
    }

    const filteredTexts = [
      {
        label: 'cards.minimumIncome',
        value: minimumIncomeValue,
      },
      {
        label: 'cards.annualFee',
        value: annualFeeValue,
      },
    ];

    const labelButtons =
      variant === 'secondary' ? 'cards.orderNow' : 'cards.moreInfo';

    return {
      id: card.id,
      title: card.name,
      imageCard: `${BASE_IMG_URL}${card.imageSlug}`,
      linkButton: card.redirectURL,
      variant: variant || 'primary',
      slug: card.slug,
      countryCode: card.countryCode,
      texts: filteredTexts,
      labelButton: labelButtons,
    };
  });

  return mappedCards;
}

export function mapLoansData(loans: Loan[], variant?: variant, label?: string) {
  const mappedLoans = loans.map((loan) => {
    let creditLimitValue;
    if (!+loan.creditLimit) {
      creditLimitValue = 'cards.noInfo';
    } else if (+loan.creditLimit === 100) {
      creditLimitValue = 'filter.flexible';
    } else {
      creditLimitValue = formatCurrency(+loan.creditLimit, loan.currencySymbol);
    }

    return {
      id: loan.id,
      title: loan.name,
      imageCard: `${BASE_IMG_URL}${loan.imageSlug}`,
      linkButton: loan.redirectURL,
      variant: variant as Cardvariant,
      countryCode: loan.countryCode,
      slug: loan.slug,
      texts: [
        {
          label: 'loans.creditLimit',
          value: creditLimitValue,
        },
        {
          label: 'loans.loanType.label',
          value: loan.loanType,
        },
      ],
      labelButton: label,
    };
  });

  return mappedLoans;
}
